webpackJsonp([241005775333813],{

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img_faq.cfa02abd.svg";

/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img_hiw.5f85378b.svg";

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img_simba-logo.b5c14dc5.svg";

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _GlobalFunctions = __webpack_require__(24);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _SingleInput = __webpack_require__(35);
	
	var _SingleInput2 = _interopRequireDefault(_SingleInput);
	
	var _img_simbaLogo = __webpack_require__(1105);
	
	var _img_simbaLogo2 = _interopRequireDefault(_img_simbaLogo);
	
	var _img_hiw = __webpack_require__(1104);
	
	var _img_hiw2 = _interopRequireDefault(_img_hiw);
	
	var _img_faq = __webpack_require__(1103);
	
	var _img_faq2 = _interopRequireDefault(_img_faq);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.onInputFocus = _this.onInputFocus.bind(_this);
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.checkForm = _this.checkForm.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	
	    _this.state = {
	      email: "",
	
	      modalError: "",
	      modalDisabled: false
	    };
	    return _this;
	  }
	
	  Modal.prototype.onInputFocus = function onInputFocus(s) {
	    (0, _GlobalFunctions.addClass)(s.target.parentNode, "input--filled"), this.setState({ modalError: "" });
	  };
	
	  Modal.prototype.onInputBlur = function onInputBlur(s) {
	    "" === s.target.value.trim() && (0, _GlobalFunctions.removeClass)(s.target.parentNode, "input--filled");
	  };
	
	  Modal.prototype.handleEmailChange = function handleEmailChange(e) {
	    this.setState({ email: e.target.value });
	  };
	
	  Modal.prototype.onClose = function onClose() {
	    this.setState({ email: "", modalError: "", modalDisabled: false });
	    this.props.onClose();
	  };
	
	  Modal.prototype.checkForm = function checkForm(e) {
	    var self = this,
	        currentUrl = "/api/simba/package",
	        currentData = "email=" + this.state.email + "&package=" + this.props.package;
	    e.preventDefault();
	
	    if (this.props.package === "Signup") {
	      currentUrl = "/api/simba/signup";
	      currentData = "email=" + this.state.email;
	    }
	
	    this.setState({ modalDisabled: true });
	    (0, _GlobalFunctions.getJSON)("POST", currentUrl, currentData, function (data) {
	      var dataArray = JSON.parse(data);
	      self.setState({
	        modalError: "<p class=\"info\">" + dataArray.message + "</p>",
	        modalDisabled: false
	      });
	    }, function (status) {
	      var statusArray = JSON.parse(status);
	      self.setState({
	        modalError: "<p>" + statusArray.error + "</p>",
	        modalDisabled: false
	      });
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    return this.props.open ? _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement("div", { className: "modal__overlay" }),
	      _react2.default.createElement(
	        "div",
	        { className: "modal" },
	        _react2.default.createElement(
	          "div",
	          { className: "modal__header" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal__header__title" },
	            this.props.package === "Signup" ? "Sign up now" : "Enroll in our academic writing school"
	          ),
	          _react2.default.createElement("button", { type: "button", onClick: this.onClose })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal__body" },
	          _react2.default.createElement(
	            "form",
	            { className: "form", onSubmit: this.checkForm },
	            _react2.default.createElement(
	              "div",
	              { "class": "form-info" },
	              "Please enter your email address"
	            ),
	            _react2.default.createElement("div", {
	              id: "modalError",
	              className: "form-error",
	              dangerouslySetInnerHTML: { __html: this.state.modalError }
	            }),
	            _react2.default.createElement(_SingleInput2.default, {
	              inputType: "email",
	              title: "",
	              name: "modalEmail",
	              content: this.state.email,
	              controlFunc: this.handleEmailChange,
	              placeholder: "E-mail",
	              focusFunc: this.onInputFocus,
	              blurFunc: this.onInputBlur,
	              svg: "M14.9,8.2c-1,0.7-2.1,1.4-3.1,2.2c-0.4,0.3-1.2,0.9-1.7,0.9h0h0c-0.5,0-1.3-0.6-1.7-0.9c-1-0.7-2.1-1.5-3.1-2.2C4.7,7.9,4,7.1,4,6.5c0-0.7,0.4-1.2,1.1-1.2h9.9c0.6,0,1.1,0.5,1.1,1.1C16,7.1,15.4,7.8,14.9,8.2z M16,13.6c0,0.6-0.5,1.1-1.1,1.1H5.1c-0.6,0-1.1-0.5-1.1-1.1V8.3c0.2,0.2,0.4,0.4,0.7,0.6c1.1,0.8,2.2,1.5,3.3,2.3c0.6,0.4,1.3,0.9,2,0.9h0h0c0.7,0,1.4-0.5,2-0.9c1.1-0.8,2.2-1.6,3.3-2.3c0.2-0.2,0.5-0.4,0.7-0.6V13.6z",
	              required: true
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "form-row form-row-submit" },
	              _react2.default.createElement("input", {
	                className: "form-submit",
	                type: "submit",
	                value: "Send",
	                disabled: this.state.modalDisabled
	              })
	            )
	          )
	        )
	      )
	    ) : null;
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	var Simba = function (_React$Component2) {
	  (0, _inherits3.default)(Simba, _React$Component2);
	
	  function Simba(props) {
	    (0, _classCallCheck3.default)(this, Simba);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, _React$Component2.call(this, props));
	
	    _this2.onInputFocus = _this2.onInputFocus.bind(_this2);
	
	    _this2.handleEmailChange = _this2.handleEmailChange.bind(_this2);
	    _this2.handleMessageChange = _this2.handleMessageChange.bind(_this2);
	
	    _this2.checkForm = _this2.checkForm.bind(_this2);
	
	    _this2.openModal = _this2.openModal.bind(_this2);
	    _this2.closeModal = _this2.closeModal.bind(_this2);
	    _this2.state = {
	      email: "",
	      message: "",
	      package: "",
	
	      contactError: "",
	      contactDisabled: false,
	
	      isOpen: false
	    };
	    return _this2;
	  }
	
	  Simba.prototype.componentDidMount = function componentDidMount() {
	    var mask = document.getElementById("mask");
	    mask.addEventListener("touchstart", this.pageClick, false);
	  };
	
	  Simba.prototype.pageClick = function pageClick(e) {
	    document.getElementsByTagName("body")[0].className = "";
	  };
	
	  Simba.prototype.onInputFocus = function onInputFocus(s) {
	    (0, _GlobalFunctions.addClass)(s.target.parentNode, "input--filled"), this.setState({ contactError: "" });
	  };
	
	  Simba.prototype.onInputBlur = function onInputBlur(s) {
	    "" === s.target.value.trim() && (0, _GlobalFunctions.removeClass)(s.target.parentNode, "input--filled");
	  };
	
	  Simba.prototype.handleEmailChange = function handleEmailChange(e) {
	    this.setState({ email: e.target.value });
	  };
	
	  Simba.prototype.handleMessageChange = function handleMessageChange(e) {
	    this.setState({ message: e.target.value });
	  };
	
	  Simba.prototype.checkForm = function checkForm(e) {
	    var self = this;
	    e.preventDefault();
	
	    this.setState({ contactDisabled: true });
	    (0, _GlobalFunctions.getJSON)("POST", "/api/simba/contactForm", "email=" + this.state.email + "&message=" + this.state.message, function (data) {
	      var dataArray = JSON.parse(data);
	      self.setState({
	        contactError: "<p class=\"info\">" + dataArray.message + "</p>",
	        contactDisabled: false
	      });
	    }, function (status) {
	      var statusArray = JSON.parse(status);
	      self.setState({
	        contactError: "<p>" + statusArray.error + "</p>",
	        contactDisabled: false
	      });
	    });
	  };
	
	  Simba.prototype.openModal = function openModal(s) {
	    this.setState({ isOpen: true, package: s });
	  };
	
	  Simba.prototype.closeModal = function closeModal() {
	    this.setState({ isOpen: false });
	  };
	
	  Simba.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "SIMBA: Not Your Average Academic Writing School | UvoCorp.com",
	        meta: [{
	          name: "description",
	          content: "If you’re searching for a way to level up your writing skills, look no further. Sign up for our online school and get access to powerful insights from experienced academic writers, self-assessment tests, and more!"
	        }, {
	          property: "og:title",
	          content: "SIMBA: Not Your Average Academic Writing School | UvoCorp.com"
	        }, {
	          property: "og:description",
	          content: "If you’re searching for a way to level up your writing skills, look no further. Sign up for our online school and get access to powerful insights from experienced academic writers, self-assessment tests, and more!"
	        }, { property: "og:site_name", content: "UvoCorp.com" }, { property: "og:type", content: "website" }, { property: "og:image", content: _cover2.default }],
	        link: [{ rel: "canonical", href: "https://www.uvocorp.com/simba.html" }]
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "header", id: "header" },
	        _react2.default.createElement(_navigation2.default, null)
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "wrapper" },
	        _react2.default.createElement(
	          "section",
	          { className: "simba-hero inner-gray" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("div", { className: "simba-hero__clouds" }),
	            _react2.default.createElement(
	              "div",
	              { className: "simba-hero__logo" },
	              _react2.default.createElement("img", { src: _img_simbaLogo2.default, alt: "Simba logo" })
	            ),
	            _react2.default.createElement(
	              "h1",
	              { className: "simba-hero__title" },
	              "We\u2019ll help you take your skills from amateur to professional"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "simba-hero__btn" },
	              _react2.default.createElement(
	                "button",
	                { type: "button", onClick: function onClick() {
	                    return _this3.openModal("Signup");
	                  } },
	                "Sign up now"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "simba-what-we-can inner-white" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "simba-what-we-can__content" },
	              _react2.default.createElement(
	                "h2",
	                { className: "inner-left" },
	                "What we can do for you"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you\u2019re an experienced writer looking for a way to invest in your skills, you\u2019ve come to the right place. SIMBA is an online academic writing school created by UVOCORP, showcasing more than 15 years\u2019 worth of knowledge and expertise in the field of academic writing. Sign up now and gain new insights with each video.",
	                " "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "simba-what-we-can__info" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Those who complete our Gold and Platinum plans will be offered to work alongside professional academic writers at UVOCORP."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "simba-what-we-can__img" },
	              _react2.default.createElement("img", { src: _img_hiw2.default, alt: "Simba What we can" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "simba-benefits inner-gray" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Our benefits"
	            ),
	            _react2.default.createElement(
	              "ol",
	              { className: "simba-benefits__list" },
	              _react2.default.createElement(
	                "li",
	                { className: "simba-benefits__item simba-benefits__item-1" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Short and informative educational videos."
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "simba-benefits__item simba-benefits__item-2" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Engaging tests and assignments to help you understand the material better."
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "simba-benefits__item simba-benefits__item-3" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Studies that take no more than a month."
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "simba-benefits__item simba-benefits__item-4" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Course completion certificate."
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "simba-how-it-work inner-white" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "simba-how-it-work__content" },
	              _react2.default.createElement(
	                "h2",
	                { className: "inner-left" },
	                "See how it works"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Our academic writing school is a unique online platform where any writer can gain new skills."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "simba-how-it-work__video" },
	              _react2.default.createElement(
	                "div",
	                { className: "simba-how-it-work__video__container" },
	                _react2.default.createElement("iframe", {
	                  width: "560",
	                  height: "315",
	                  src: "https://www.youtube.com/embed/H-K1P0JTdjU",
	                  title: "YouTube video player",
	                  frameborder: "0",
	                  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
	                  allowfullscreen: true
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "simba-pricing inner-gray" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "h2",
	              { className: "inner-left" },
	              "Choose your plan"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "We offer 2 plans with different benefits and levels of intensity."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "simba-pricing__table" },
	              _react2.default.createElement(
	                "div",
	                { className: "simba-pricing__table__col simba-pricing__table__header" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th simba-pricing__table__th-first" },
	                  "Key features"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th" },
	                  "Email support"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th" },
	                  "Educational videos"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th" },
	                  "Basic self-assessment tests"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th" },
	                  "Extra self-assessment tests"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th" },
	                  "Final exam"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th" },
	                  "SIMBA certificate"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__th" },
	                  "UVOCORP job offer"
	                ),
	                _react2.default.createElement("div", { className: "simba-pricing__table__th simba-pricing__table__total" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "simba-pricing__table__col" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__td simba-pricing__table__td-first" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__title" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Plan"
	                    ),
	                    "SIMBA Gold"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__desciption" },
	                    "Choose Gold if you\u2019re looking for a reasonable compromise. This plan includes all the premium features except for final exam and SIMBA certificate."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Email support"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Educational videos"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Basic self-assessment tests"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Extra self-assessment tests"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Final exam"
	                  },
	                  _react2.default.createElement("i", { className: "ico-minus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "SIMBA certificate"
	                  },
	                  _react2.default.createElement("i", { className: "ico-minus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "UVOCORP job offer"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__td simba-pricing__table__total" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__total__price" },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "$499"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__total__btn" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "form-submit",
	                        onClick: function onClick() {
	                          return _this3.openModal("Gold");
	                        }
	                      },
	                      "Enroll"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "simba-pricing__table__col simba-pricing__table__recomended" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__td simba-pricing__table__td-first" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__title" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Plan"
	                    ),
	                    "SIMBA Platinum"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__desciption" },
	                    "Choose Platinum to access all our assignments and tests, get extra feedback, and receive premium support. It\u2019s SIMBA at its best."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Email support"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Educational videos"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Basic self-assessment tests"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Extra self-assessment tests"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "Final exam"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "SIMBA certificate"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "simba-pricing__table__td",
	                    "data-title": "UVOCORP job offer"
	                  },
	                  _react2.default.createElement("i", { className: "ico-plus" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "simba-pricing__table__td simba-pricing__table__total" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__total__price" },
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "$599"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "simba-pricing__table__total__btn" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "form-submit",
	                        onClick: function onClick() {
	                          return _this3.openModal("Platinum");
	                        }
	                      },
	                      "Enroll"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "simba-pricing__info" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "For the best results, we recommend going for the",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Gold or Platinum plan"
	                ),
	                ".",
	                " "
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "SIMBA is all about practice, and these programs offer all the training you need and even more than that."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "simba-contacts inner-gray" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "simba-contacts__container" },
	              _react2.default.createElement(
	                "h2",
	                { className: "inner-left" },
	                "Got any questions?"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "simba-contacts__form" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Feel free to email us at",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "mailto:simba@uvocorp.com" },
	                    "simba@uvocorp.com"
	                  ),
	                  " or simply fill out the form below. We\u2019ll do our best to get back to you as soon as possible."
	                ),
	                _react2.default.createElement(
	                  "form",
	                  { className: "form", onSubmit: this.checkForm },
	                  _react2.default.createElement(_SingleInput2.default, {
	                    inputType: "email",
	                    title: "",
	                    name: "contactEmail",
	                    content: this.state.email,
	                    controlFunc: this.handleEmailChange,
	                    placeholder: "E-mail",
	                    focusFunc: this.onInputFocus,
	                    blurFunc: this.onInputBlur,
	                    svg: "M14.9,8.2c-1,0.7-2.1,1.4-3.1,2.2c-0.4,0.3-1.2,0.9-1.7,0.9h0h0c-0.5,0-1.3-0.6-1.7-0.9c-1-0.7-2.1-1.5-3.1-2.2C4.7,7.9,4,7.1,4,6.5c0-0.7,0.4-1.2,1.1-1.2h9.9c0.6,0,1.1,0.5,1.1,1.1C16,7.1,15.4,7.8,14.9,8.2z M16,13.6c0,0.6-0.5,1.1-1.1,1.1H5.1c-0.6,0-1.1-0.5-1.1-1.1V8.3c0.2,0.2,0.4,0.4,0.7,0.6c1.1,0.8,2.2,1.5,3.3,2.3c0.6,0.4,1.3,0.9,2,0.9h0h0c0.7,0,1.4-0.5,2-0.9c1.1-0.8,2.2-1.6,3.3-2.3c0.2-0.2,0.5-0.4,0.7-0.6V13.6z",
	                    required: true
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-row form-row-noicon" },
	                    _react2.default.createElement("textarea", {
	                      name: "contactMessage",
	                      className: "form-input",
	                      placeholder: "Type your message here",
	                      value: this.state.message,
	                      onFocus: this.onInputFocus,
	                      onBlur: this.onInputBlur,
	                      onChange: this.handleMessageChange,
	                      required: true
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-row form-row-submit" },
	                    _react2.default.createElement("div", {
	                      id: "contactError",
	                      className: "form-error",
	                      dangerouslySetInnerHTML: {
	                        __html: this.state.contactError
	                      }
	                    }),
	                    _react2.default.createElement("input", {
	                      className: "form-submit",
	                      type: "submit",
	                      value: "Submit",
	                      disabled: this.state.contactDisabled
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "simba-contacts__img" },
	                _react2.default.createElement("img", { src: _img_faq2.default, alt: "Simba FAQ" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "simba-footer inner-gray" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "/pdf/simba_terms_of_service.pdf" },
	                "Simba Terms of Service and Refunds Policy"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(Modal, {
	          open: this.state.isOpen,
	          "package": this.state.package,
	          onClose: this.closeModal
	        }),
	        _react2.default.createElement(_footer2.default, null)
	      ),
	      _react2.default.createElement("div", { id: "mask", className: "c-mask" })
	    );
	  };
	
	  return Simba;
	}(_react2.default.Component);
	
	exports.default = Simba;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-simba-html-js-cec342f3323d4564cdac.js